import React, {InputHTMLAttributes, useState} from 'react';

import {ReactComponent as CrossIcon} from 'assets/svg/cross.svg';
import {ReactComponent as DownloadIcon} from 'assets/svg/download.svg';
import {ReactComponent as UploadIcon} from 'assets/svg/download2.svg';
import {Icon} from 'components/ui-kit/Icon';

import {colors} from 'theme';

import {NativeInput, Root, Label, FileName, LoadedWrapper, CloseFileIcon} from './styled';
import {InputVariant} from './types';

export interface InputFileProps extends InputHTMLAttributes<HTMLInputElement> {
    variant?: InputVariant;
    className?: string;
    initialValue?: string;
    label?: string;
    updatedDesign?: boolean;
}

export const InputFile = ({
    className,
    variant = InputVariant.Normal,
    onChange,
    initialValue,
    label,
    updatedDesign,
    ...otherProps
}: InputFileProps) => {
    const [value, setValue] = useState<string | null>(initialValue || null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const inputValue = (e?.target as HTMLInputElement).value.split(/(\\|\/)/g).pop();
        onChange && onChange(e);
        inputValue && setValue(inputValue);
    };
    const handleBtnClick = (evt: any) => {
        evt.preventDefault();
        onChange && onChange(evt);
        setValue(null);
    };

    return (
        <Root className={className} updatedDesign={updatedDesign}>
            {!value && (
                <Label variant={variant} updatedDesign={updatedDesign}>
                    {updatedDesign ? (
                        <Icon
                            source={UploadIcon}
                            width={16}
                            height={16}
                            strokeColor={colors.white}
                            fillColor={'transparent'}
                            style={{marginRight: 8}}
                        />
                    ) : (
                        <DownloadIcon style={{width: 15, height: 15, marginRight: 10}} />
                    )}
                    {label || 'Загрузить файл'}
                    <NativeInput {...otherProps} onChange={handleChange} />
                </Label>
            )}

            {value && (
                <LoadedWrapper updatedDesign={updatedDesign}>
                    <FileName updatedDesign={updatedDesign}>{value}</FileName>
                    <CloseFileIcon
                        source={CrossIcon}
                        width={12}
                        height={12}
                        onClick={handleBtnClick}
                    />
                </LoadedWrapper>
            )}
        </Root>
    );
};

export {InputVariant};
